module.exports = __webpack_public_path__ + "img/banner_p2p.83a6c61b.png";